export default __webpack_public_path__ + "static/media/ProceduresOrangeIcon.8ea0bc3a.png";